<template>
  <div class="header">
    <div class="system-title">
      <i class="logo-layer">
        <img class="logo" src="@/assets/images/logo.png" alt />
      </i>
      <div class="system-name">
        <span class="system-name-lable">国家铁路局安全技术中心</span>
        <span class="system-name-lable">中国职业安全健康协会铁道分会</span>
      </div>
    </div>
    <div class="newset_navright" id="cuctom-nav">
      <div
        class="menu-list not-select"
        id="menu-list"
        @mousedown="mousedownStart"
        @mousemove="mousemoveStart"
        @mouseup="mouseupStart"
        @mouseleave="mouseupStart"
      >
        <ul class="scroll-ul">
          <li
            class="menu-item"
            v-for="(item, index) in tagsList.filter(
              (item) => item.name !== 'index'
            )"
            :key="index"
            :ref="'viewList' + index"
            :class="{ active: isActive(item.path) }"
            @click="SwitchTags(item)"
          >
            <span>{{ item.title }}</span>
            <i
              class="close-icon el-icon-circle-close"
              @click.stop="closeTags(index, item.path)"
            ></i>
          </li>
        </ul>
      </div>
      <div class="system-operation">
        <div class="input-layer">
          <el-autocomplete
            v-model="state"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
          />
        </div>
        <div class="tips">
          <i class="el-icon-question"></i>
        </div>
        <div class="notice">
          <i class="el-icon-bell"></i>
        </div>
        <div class="avatar">
          <img
            src="@assets/images/defaultImg.png"
            alt
          />
        </div>
        <div class="username-layer">
          <span>{{titleName}}</span>
          <!-- <span>{{ userInfo_Name }}({{ userInfo_ID }})</span> -->
        </div>
        <ul class="operation">
          <li class="opt_item" @click="handleClose" title="退出登录">
            <div class="notice">
              <span class="iconfont icon-tuichu"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import menus from "@/util/menus.js";
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessageBox } from 'element-plus'
import {getUserInfo,ClearUserInfo,ClearToken} from '@/util/authority'
import {
  ref,
  reactive,
  toRefs,
  computed,
  onMounted,
  watch,
  getCurrentInstance,
} from 'vue'
export default {
  setup(props, ctx) {
    const links = ref([])
    const setMenu = (menulist)=> {
      let isAdmin = sessionStorage.getItem("UserID").toUpperCase() == "ADMIN";
      let permissions = [];
      if(sessionStorage.getItem("userPermissions")) {
        permissions = JSON.parse(sessionStorage.getItem("userPermissions"));
      }
      let menu_first = menulist.filter((item) => {
        return item.pid == "100";
      });
      let menuList = [];
      menu_first.forEach((item) => {
        let minimenu = item;
        minimenu.subs = menulist.filter((menu) => {
          return menu.pid == item.id  && (isAdmin || permissions.includes(menu.pathName) || permissions.includes(menu.pathName+'View'));
        });
        if(minimenu.subs.length > 0 || (minimenu.subs.length == 0 && minimenu.pathName != "")) {
          menuList.push(minimenu);
        }
      });
      return menuList;
    }
    const loadAll = () => {
      let CmainList = []
      let mainList = setMenu(menus);
      mainList.forEach((element) => {
        if(element.subs) {
          element.subs.forEach((item) => {
            let mainValue = {
              value: item.title,
              ...item,
            }
            CmainList.push(mainValue)
          })
        }
      })
      return CmainList
    }
    const handleSelect = (item) => {
      let routerObj = {
        name: item.title,
        path: `${item.path}`,
      }
      router.push(routerObj)
      state.value = ''
    }
    const querySearchAsync = (queryString, cb) => {
      const results = queryString
        ? links.value.filter(createFilter(queryString))
        : links.value
      cb(results)
    }
    const createFilter = (queryString) => {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    }
    const store = useStore()
    const router = useRouter()
    const emitter =
      getCurrentInstance()?.appContext.config.globalProperties.emitter
    let navdes = ref(null)
    let data = reactive({
      userInfo_Name: '',
      userInfo_ID: '',
      titleName: '',
      spreadflag: true,
      indexContent: -1,
      tagsList: [],
      transW: 0,
      isSlider: false, // 显示左右箭头 默认不显示
      searchInput: '', //搜索
      // custom
      menuList: [
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
        { name: '基础建档', key: new Date().getTime() },
      ],
      // custom --- end
    })

    emitter.on('closeOneTagForName', (path) => {
      var index = data.tagsList.findIndex((i) => {
        return i.path == path
      })
      if (index > -1) {
        closeTags(index, path)
      }
    })
    if (data.tagsList.length < 10) {
      setTags(router.currentRoute.value)
    }
    watch(
      () => router.currentRoute.value,
      (newValue, oldValue) => {
        setTags(newValue, oldValue)
      }
    )
    watch(
      () => data.tagsList,
      (newValue, oldValue) => {
        if (data.tagsList.length > 9) {
          if (data.tagsList.length >= 10) {
            store.commit('setisOpenRouter', false)
          }
          return
        }
        if (data.tagsList.length < 10 && !store.getters['GetisOpenRouter']) {
          store.commit('setisOpenRouter', true)
        }
      }
    )
    onMounted(() => {
      links.value = loadAll()
      data.userInfo_Name = getUserInfo().UserName
      data.userInfo_ID =   getUserInfo().CodeID
      data.titleName = data.userInfo_Name + '(' + data.userInfo_ID + ')'
      if(document.querySelector('#menu-list')==null)return;
      document.querySelector('#menu-list').onmousewheel = (e) => {
        let dom_ = document.querySelector('.menu-list')
        let remainder = dom_.scrollLeft % 144
        // setTimeout(() => {
        if (e.wheelDelta > 0) {
          //向下滚动
          dom_.scrollLeft = dom_.scrollLeft + (144 - remainder)
        } else {
          //向上
          dom_.scrollLeft = dom_.scrollLeft - (144 - remainder)
        }
      }
    })
    // 设置标签
    function setTags(route, oldRoute) {
      var flag = false
      let array = store.state.browseRecord
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        if (element && element.path == route.fullPath) {
          flag = true
          break
        }
      }
      if (route.meta.breadcrumb != undefined) {
        if (!flag) {
          var obj = new Object()
          obj.path = route.fullPath
          obj.billNumber = ''
          obj.BillOpState = ''
          obj.BeforeOpState = ''
          obj.brData = null
          obj.key = route.meta.breadcrumb.id
          store.commit('setBrowseRecord', obj)
        }
      }
      let isExist = data.tagsList.some((item) => {
        return item.path === route.path
      })
      if(isExist) {
        const indexKey = data.tagsList.findIndex(item=>item.path === route.path)
        data.tagsList[indexKey].query = route.query
      }
      
      if (!isExist && route.fullPath != '/login' && route.fullPath != "/index") {
        data.tagsList.push({
          title: route.meta.title,
          path: route.path,
          name: route.matched[1].components.default.name,
          query: route.query,
          meta: route.meta,
        })
      }
      if (route.params.isReplace && oldRoute && data.tagsList.length > 0) {
        //替换功能
        data.tagsList.some((v, i) => {
          if (v.path === oldRoute.fullPath) {
            data.tagsList.splice(i, 1)
            return true
          }
          return false
        })
      }
      // 当导航栏 导航数量增加时 调用 使导航 偏移到 最后面
      if (!isExist) {
        setNavTrans('add')
      }
      emitter.emit('tags', data.tagsList)
    }

    // 设置导航栏 偏移
    function setNavTrans(type) {
      return
      /*
       * add 增加导航数 del 双击删除 other 关闭其他的  right  关闭右侧的
       * navWidth 导航条总宽
       * clientNavW 导航条 可视宽度
       */
      if (type === 'add') {
        const clientNavW = document.querySelector('.navdes_fl').clientWidth
        if (navWidth > clientNavW) {
          transW = -navWidth - 20 + clientNavW
        }
      } else if (type === 'del') {
        if (transW < 0) {
          transW = transW + 145 > 0 ? 0 : transW + 145
        }
      } else if (type === 'other') {
        transW = 0
      } else if (type === 'right') {
        const clientNavW = document.querySelector('.navdes_fl').clientWidth
        if (navWidth < clientNavW) {
          transW = 0
        } else {
          transW = -navWidth + clientNavW
        }
      }
      navSider()
    }
    function navSider() {
      isSlider = navWidth > document.querySelector('.navdes_fl').clientWidth
      setBgStyle()
    }
    function setBgStyle() {
      const checkTag = document.querySelector('.newset_navul .current')
      if (checkTag) {
        const childTag = checkTag.parentNode.children
        for (var i = 0; i < childTag.length; i++) {
          childTag[i].classList.remove('preborder')
        }
        const prevTag = checkTag.previousSibling
        const nextTag = checkTag.nextSibling
        prevTag && prevTag.classList.add('preborder')
      }
    }

    function isActive(path) {
      return path === router.currentRoute.value.path
    }
    // 点击 导航条进行左右平移
    function trans(type) {
      if (type === 'left') {
        const clientNavW = document.querySelector('.navdes_fl').clientWidth
        if (transW <= -navWidth + clientNavW) return
        transW = transW - 145
      } else if (type === 'right') {
        if (transW >= 0) return
        transW = transW + 145 > 0 ? 0 : transW + 145
      }
    }
    // 展开收起
    function spFlag() {
      data.spreadflag = !data.spreadflag
      ctx.emit('spreadBtn', data.spreadflag)
    }
    // 导航菜单
    function SwitchTags(item, index) {
      if (
        item.title == router.currentRoute.value.name &&
        item.path == router.currentRoute.value.path
      ) {
        return
      }
      if (
        item.path.split('/')[1] == 'index' ||
        item.path.split('/')[1] == 'plugdownload'
      ) {
        router.push({ path: item.path })
        return
      } else {
        if(item.query && Object.keys(item.query).length > 0) {
          router.push({ path: item.path, query: item.query })
        } else {
          router.push({ name: item.title })
        }
      }
      emitter.emit('SwitchTags', item)
      setBgStyle()
    }

    // 关闭单个标签
    function closeTags(index, path) {
      data.indexContent = data.tagsList[index]

      DeletePage(path)
      const delItem = data.tagsList.splice(index, 1)[0]
      emitter.emit('tags', data.tagsList)
      const item = data.tagsList[index]
        ? data.tagsList[index]
        : data.tagsList[index - 1]
      if (item && delItem) {
        delItem.path === router.currentRoute.value.path &&
          router.push(item.path)
      } else {
        router.push('/')
      }
      //关闭iframe标签
      if(delItem) {
        var id = delItem.meta.breadcrumb.id
        var iframe = document.getElementById(id)
        if (iframe) {
          iframe.remove()
        }
      }
      setNavTrans('del')
    }
    //关闭页签时候删除对应的记录
    function DeletePage(path) {
      //删除对应的记录
      let index_de = ''
      let array = store.state.browseRecord
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        if (element && element.path == path) {
          index_de = index
          break
        }
      }
      array.splice(index_de, 1)
    }
    // 关闭其他页签
    function closeOthertags(index, path) {
      let curItem = []
      data.tagsList.forEach((item, index) => {
        if (item.path === path) {
          curItem.push(item)
        }
        if (item.path === '/index') {
          curItem.push(item)
        }
      })
      let tagsCloseList = data.tagsList.filter((item) => {
        if (
          !curItem.find((cItem) => {
            return cItem.meta.breadcrumb.id == item.meta.breadcrumb.id
          })
        ) {
          return item
        }
      })

      data.tagsList = curItem
      emitter.emit('tags', data.tagsList)
      router.push({
        path: path,
      })
      setNavTrans('other')
    }
    // 关闭右侧页签
    function closeRightTags(index, path) {
      let lengthIndex = index + 1
      data.tagsList = data.tagsList.splice(0, lengthIndex)
      emitter.emit('tags', data.tagsList)
      router.push({
        path: path,
      })
      setNavTrans('right')
    }
    // 打开关闭的页签
    function openTags() {
      const isexid = data.tagsList.filter(
        (item) => item.name == data.indexContent.name
      )
      if (isexid.length) return
      if (data.indexContent != -1) {
        data.tagsList.push(data.indexContent)
      }
      emitter.emit('tags', data.tagsList)
      isActive(data.indexContent.path)
      router.push({
        path: data.indexContent.path,
      })
      setBgStyle()
    }
    // 退出登录
    function handleClose(done) {
      ElMessageBox.confirm('您确认退出系统？', '提示', {
        cancelButtonClass: 'cancelstyle',
        confirmButtonClass: 'confirmstyle',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      })
        .then(() => {
          loginout()
        })
        .catch(() => {
          return
        })
    }
    function loginout() {
      localStorage.removeItem('UserID')
      localStorage.removeItem('WorkID')
      localStorage.removeItem('UserName')
      ClearUserInfo();
      ClearToken();
      sessionStorage.clear()
      router.push('/login')
    }

    // 检测鼠标动作
    let scroll_start = 0
    let scroll_flag = false
    const mousedownStart = (e) => {
      scroll_flag = true
      scroll_start = e.x
    }
    const mousemoveStart = (e) => {
      if (!scroll_flag) return
      //move num
      let dom_ = document.querySelector('.menu-list')
      let move = e.x - scroll_start
      dom_.scrollLeft = dom_.scrollLeft - move * 0.95
      scroll_start = e.x
    }
    const mouseupStart = () => {
      scroll_flag = false
    }
    let state = ref('')
    return {
      ...toRefs(data),
      isActive,
      navdes,
      spFlag,
      trans,
      SwitchTags,
      closeTags,
      closeOthertags,
      closeRightTags,
      openTags,
      handleClose,
      isOpenRouter: computed(() => store.getters.GetisOpenRouter),
      navWidth: computed(() => (data.tagsList.length - 1) * 145), // 设置导航栏宽度
      mousedownStart,
      mousemoveStart,
      mouseupStart,
      links,
      state,
      querySearchAsync,
      loadAll,
      createFilter,
      handleSelect,
    }
  },
  // watch: {
  //   isCloseRouter(newValue, oldValue) {
  //     if (newValue != "") {
  //       let tagpath = tagsList.find((item) => {
  //         return item.path == newValue;
  //       });
  //       let index = tagsList.indexOf(tagpath);
  //       closeTags(index, newValue);
  //       setisCloseRouter("");
  //     }
  //   },
  // },
}
</script>
<style >
/* .header {
  overflow-y: scroll;
} */
.headerinputsearch .el-input__inner {
  /* border-radius: 25px;
  background-color: #324157; */
  background-color: transparent !important;
  border: none !important;
  color: #778393;
  border: aliceblue;
  width: 300px;
  height: 36px;
  border-radius: 0 25px 25px 0;
  vertical-align: top;
  height: 36px;
  padding: 0 !important;
}
.headerinputsearch .el-input ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #778393 !important;
}
.headerinputsearch .el-input :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #778393 !important;
}
.headerinputsearch .el-input ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #778393 !important;
}
.headerinputsearch .el-input :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #778393 !important;
}
.headerinputsearch .el-input__icon.el-icon-search {
  color: #778393;
}
.header .save_btm {
  padding-top: 15px;
}
.header .save_btm .save_btn {
  width: 260px;
  height: 42px;
  background-color: #409eff;
  border-radius: 5px;
  font-size: 14px;
  line-height: 42px;
  color: #ffffff;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
}
.header .save_btm .save_btn:hover {
  background-color: rgba(64, 158, 255, 0.89);
}
.header .system_set .syset_list .sl_item {
  display: flex;
  box-sizing: border-box;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #eeeeee;
  padding: 20px 10px;
  position: relative;
}
.header .sl_item .set_info {
  width: 90%;
  word-wrap: break-word;
}
.header .sl_item .set_icon {
  width: 10%;
  text-align: right;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.header .sl_item .set_icon .iconfont {
  color: #cdd7df;
  font-size: 14px;
}
.header .content_sa_skin.none {
  display: none;
}
.header .content_sa_skin li {
  cursor: pointer;
}
.header .content_sa_skin li.sl_item:not(:first-child):hover {
  background: #eeeeee;
}
.header .select_skin .skin_item {
  height: 80px;
  line-height: 80px;
  /* margin-bottom: 20px; */
  color: #666666;
  font-size: 14px;
  display: flex;
  border-bottom: 1px solid #eeeeee;
}
.header .select_skin .skin_item span {
  width: 60%;
  text-indent: 2em;
}
.header .slide_area {
  background-color: red;
  /* height: 100%; */
  width: 300px;
  overflow-y: scroll;
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  z-index: 66;
  background-color: #fbfbfb;
  border: solid 1px #eeeeee;
  transition: all 0.27s linear;
}
.header .slider_mask {
  background-color: Rgba(51, 51, 51, 0.5);
  /* height: 100%; */
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}
.header .slide_area.trans {
  width: 0;
}
.header .slide_area .header_title {
  height: 50px;
  background-color: #eeeeee;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  line-height: 50px;
  color: #666666;
  text-indent: 1em;
}
* {
  list-style: none;
}
.header .operation {
  height: 100%;
  /* width: 300px; */
  display: flex;
  justify-content: flex-end;
}
.header.header_saas .operation {
  width: 220px;
}
.header .operation .opt_item {
  width: 72px;
  height: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header .operation .opt_item:hover {
  background-color: #324157;
}
.header .iconfont {
  /* font-size: 20px;
  color: #778393;
  line-height: 72px; */
}
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  font-size: 22px;
  color: #fff;
}
.collapse-btn {
  width: 250px;
  height: 70px;
  float: left;
  /* padding: 0 21px; */
  cursor: pointer;
  line-height: 70px;
  box-sizing: border-box;
}
.collapse-btn:hover {
  background-color: inherit;
}
.collapse-btn > .logo_img.logo {
  height: 100%;
  width: 250px;
  position: relative;
  /* padding-left: 25px;
  padding-right: 54px; */
}
.collapse-btn > .logo_img.logo .logoPicUrl {
  width: 240px;
  height: 52px;
  /* padding:10px 0; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.collapse-btn > .logo_img.logo > .img {
  width: 170px;
  height: 27px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* background-image: url('../../assets/log.png') no-repeat; */
  /* background: url("../../assets/log_white.png") no-repeat; */
  background-size: 100% 100%;
}
.header .logo {
  float: left;
  width: 250px;
  line-height: 70px;
}
.header .search_panel {
  margin-left: 12px;
}
.header-right {
  float: right;
  /* width: 300px; */
  /* padding-right: 50px; */
}
.header-user {
  float: left;
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  margin-right: 15px;
}
.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
  /* width:220px; */
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
/* .el-dropdown-link {
  color: #fff;
  cursor: pointer;
} */
.el-dropdown-menu__item {
  text-align: center;
}
.header .search_panel {
  width: auto !important;
  background-color: #adcef4;
  height: 36px;
  margin-top: 17px;
  border-radius: 25px;
}
.searchpaneldiv .el-icon-search {
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  width: 30px;
  text-align: right;
  font-size: 18px;
  color: #7b889a;
}
.headerinputsearch {
  display: inline-block;
  vertical-align: top;
  height: 36px;
}
.headerinputsearch .el-input--suffix {
  vertical-align: top;
  height: 36px;
}
.headerinputsearch .el-icon-circle-close {
  vertical-align: top;
  font-size: 18px;
  color: #778393;
  height: 36px;
  line-height: 36px;
}
.headerinputsearch .el-input__suffix {
  right: 10px !important;
}
/* .el-loading-spinner .path{
  stroke:#ffffff!important;
}
.el-loading-spinner .el-loading-text{
  color:#ffffff!important;
} */
</style>

<style lang="scss">
.not-select {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  cursor: pointer;
  transition: all 0.2s linear;
}
.header {
  display: flex;
}
.system-title {
  width: 220px;
  min-width: 220px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo-layer {
    // width: 42px;
    // height: 42px;
    // border-radius: 50%;
    // display: flex;
    // overflow: hidden;
    margin-right: 12px;
    .logo {
      width: 36px;
      height: 100%;
      border-radius: 8px;
    }
  }
  .system-name {
    display: flex;
    flex-direction: column;
    text-align-last: justify;
    .system-name-lable {
      font-size: 12px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      // line-height: 36px;
    }
  }
}
#cuctom-nav .menu-list::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
#cuctom-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  .menu-list {
    margin-left: 30px;
    margin-right: 30px;
    overflow: auto;
    width: calc(100% - 460px);
    height: 57px;
    position: relative;
    padding-top: 15px;
    box-sizing: border-box;
    .scroll-ul {
      display: flex;
      position: absolute;
      left: 0;
    }
    .menu-item.active {
      background: #1c6de4;
    }
    .menu-item {
      width: 120px;
      height: 28px;
      line-height: 28px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 100px 100px 100px 100px;
      opacity: 1;
      color: #fff;
      padding-right: 28px;
      box-sizing: border-box;
      text-align: center;
      margin-right: 24px;
      float: left;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
      .close-icon {
        color: #fff;
        font-size: 18px;
        vertical-align: middle;
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
  }
  .system-operation {
    // width: 460px;
    min-width: 460px;
    height: 100%;
    display: flex;
    align-items: center;
    .input-layer {
      width: 210px;
      input {
        background-color: rgba(240, 242, 245, 0.3);
        height: 28px;
        border: none;
        border-radius: 2px;
        color: #fff;
      }
    }
    .tips {
      color: #fff;
      width: 48px;
      margin-left: 14px;
      cursor: pointer;
      text-align: center;
      i {
        font-size: 16px;
      }
    }
    .notice {
      color: #fff;
      width: 48px;
      margin-right: 12px;
      text-align: center;
      i {
        font-size: 18px;
      }
    }
    .avatar {
      width: 26px;
      height: 26px;
      display: flex;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .username-layer {
      min-width: 60px;
      span {
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
.newset_navleft {
  min-width: 208px;
}
</style>
<style scoped>
@import '../../common/newmenu/newmenu.css';
.nav_inner > em {
  font-size: 12px;
}
</style>


